export const MERCURIO_API = {
  public: process.env.VUE_APP_API_PUBLIC_MERCURIO,
  private: process.env.VUE_APP_API_PRIVATE_MERCURIO
};

export const MSPTOOLS_API = {
  url: process.env.VUE_APP_MSPTOOLS_API_URL,
  biological: {
    path: "biological",
    years: [1993, 2019],
    sourceData: "CMEMS - GLOBAL REANALYSIS PHY 001 030"
  },
  waveEnergy: {
    path: "wave",
    years: [1979, 2018],
    sourceData: "ERA INTERIM"
  },
  windEnergy: {
    path: "wind",
    years: [1979, 2018],
    sourceData: "ERA INTERIM"
  },
  historicalData: {
    path: "historical",
    variables: ["temperature", "salinity"]
  }
};

export const SENSORS_API = {
  url: process.env.VUE_APP_SENSORS_API_URL
};
